var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._g({staticClass:"vc-voice-play-btn",class:{ 'vc-voice-play-btn--playing': _vm.playing },attrs:{"type":"text","loading":_vm.loading,"title":_vm.resolvedTitle}},_vm.$listeners),[(!_vm.loading)?_c('Icon',{attrs:{"type":_vm.playing ? 'ios-pause' : 'ios-play',"size":_vm.iconSize}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }